( function ( $ ) {
	class Menu {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {
			this.siteHeader = $( '#masthead' );
			this.body = $( 'body' );
			this.window = $( window );
			this.searchIcon = $( '#js-search-icon' );
			this.headerButtons = $('.header-wrap .header-nav__right');
			this.headerSearch = $('.header-wrap .header-search');
			this.searchForm = $( '.header-wrap .header-search-form' );
			this.searchInput = $( '.header-wrap .search-field' );
			this.menuBtn = $( '#menu-button' );
			this.mobileMenu = $( '#header-menu-mobile' );
			this.desktopMenu = $( '.header-menu-desktop .header-nav__center' );
			this.headerMenuDesktop = $( '.header-menu-desktop' );
			this.headerLeft = $( '.header-left' );
			this.headerLinks = this.desktopMenu.find( '.header-nav__link' );
			this.siteBranding = $( '.site-branding' );
			this.siteCustomLogo = this.siteBranding.find( '.custom-logo-link' );
			this.siteDarkLogo = this.siteBranding.find( '.custom-logo-dark-theme' );
			this.parentMenuLink = $( '.header-menu-desktop .header-nav__list.has-submenu' );
			this.resourceLink = $( '.header-nav__link.is-resources' );
			this.addEvents();

		}

		/**
		 * Add Events.
		 *
		 * @return {void}
		 */
		addEvents() {

			//this.window.resize( () => this.setSearchbarPosition() );
			this.searchIcon.on( 'click', () => this.toggleSearch() );
			this.menuBtn.on( 'click', () => this.toggleMenu() );

			// $( 'body:not( .header-search-form.search-open ):not( .search-icon ):not( span.search-icon-el )' ).on( 'click', ( e ) => {
			// 	if ( $( e.target ).hasClass( 'search-icon-el' ) || $( e.target ).hasClass( 'search-icon' ) || $( e.target ).hasClass( 'search-field' ) || 'none' !== $( '.header-menu-desktop' ).css( 'display' ) ) {
			// 		return;
			// 	}

			// 	if ( this.searchForm.hasClass( 'search-open' ) ) {
			// 		this.toggleSearch( false );
			// 	}
			// } );

			let thisObj = this;
			// If parent menu item has children, toggle the 'desktop-submenu-open' class on hover in and out, to handle dark theme.
			this.parentMenuLink.hover( function() {
				if ( thisObj.searchForm.hasClass( 'search-open' ) ) {
					return;
				}

				// Remove the 'expanded' class from all menu links first, before adding.
				$( '.header-nav__link' ).removeClass( 'expanded' );
				$( this ).find( '.header-nav__link' ).addClass( 'expanded' );
				thisObj.siteHeader.addClass( 'desktop-submenu-open' );

			}, function() {
				if ( thisObj.searchForm.hasClass( 'search-open' ) ) {
					return;
				}

				$( this ).find( '.header-nav__link' ).removeClass( 'expanded' );
				thisObj.siteHeader.removeClass( 'desktop-submenu-open' );

			} );

			this.headerLinks.on( 'click', ( event ) => {
				if ( thisObj.searchForm.hasClass( 'search-open' ) ) {
					event.preventDefault();
				}
			} );

			// Make the resource link non clickable.
			this.resourceLink.on( 'click', ( event ) => {
				event.preventDefault();
			} );

			// Remove click action from Resources link in desktop footer.
			$( '.footer-desktop .nav_two .nav_two__list > .nav_two__link' ).on( 'click', function( e ) {
				e.preventDefault();
			} );

		}

		/**
		 * Toggle Search Visibility
		 *
		 * @param {bool} submit Whether to submit search form.
		 *
		 * @return {void}
		 */
		toggleSearch( submit = true ) {

			this.searchForm.toggleClass( 'search-open' );
			this.searchIcon.toggleClass( 'search-open' );
			this.siteHeader.toggleClass( 'search-open' );
			this.headerSearch.toggleClass( 'search-open' );
			this.headerButtons.toggleClass( 'search-open' );

			if ( ! this.desktopMenu.hasClass( 'search-open' ) ) {
				this.desktopMenu.removeClass( 'search-closed' );
				this.desktopMenu.addClass( 'search-open' );
			} else {

				this.desktopMenu.removeClass( 'search-open' );
				this.desktopMenu.addClass( 'search-closed' );
			}

			//this.setSearchbarPosition();
			this.toggleInputFocus();
		}

		/**
		 * Toggle Input focus.
		 *
		 * Toggle the focus on input element,
		 * when search bar is open or closed.
		 *
		 * @return {void}
		 */
		toggleInputFocus() {
			if ( this.searchForm.hasClass( 'search-open' ) ) {
				this.searchInput.focus();
			} else {
				this.searchInput.focusout();
				this.searchInput.val( '' );
			}
		}

		/**
		 * Toggle Menu visibility.
		 *
		 * @return {void}
		 */
		toggleMenu() {
			this.mobileMenu.toggleClass( 'menu-open' );
			this.siteHeader.toggleClass( 'menu-open' );
			this.menuBtn.toggleClass( 'menu-open' );
			this.body.toggleClass( 'fixed' );
		}

		/**
		 * Set Search bar position.
		 *
		 * We cannot give search bar position absolution because
		 * The submenu on hover needs to have full width, so it
		 * needs to have position absolute in relation to header.
		 * Hence handling the position of search bar with JavaScript.
		 *
		 * @return {void}
		 */
		// setSearchbarPosition() {

		// 	// Only to be set at large screen.
		// 	if ( 1024 > window.innerWidth ) {
		// 		return;
		// 	}

		// 	const offset = 194;
		// 	const searchBarWidth = this.headerLeft.width() - offset;
		// 	const searchBarLeftPos = this.siteBranding.position().left;

		// 	if ( $( '.header-wrap .header-search-form' ).hasClass( 'search-open' ) ) {
		// 		this.searchForm.css( {
		// 			'width': `${ searchBarWidth }px`,
		// 			'left': searchBarLeftPos + offset
		// 		} );
		// 	} else {
		// 		this.searchForm.css( {
		// 			'width': 0,
		// 			'left': 0
		// 		} );
		// 	}
		// }

	}

	new Menu();

} )( jQuery );
